import React from "react"

import Layout from "@layout/layout"
import {graphql, Link, withPrefix} from "gatsby"
import TableOfContents from '../components/about-us/table-of-contents'
import SEO from "@layout/seo";
import Helmet from "react-helmet";

export default ({data}) => (
  <Layout>
    <SEO
      title={'Poradnia ginekologiczna Tiliamed - wizyta u ginekologa już dziś!'}
      description={'Specjaliści położnictwa i ginekologii, szeroki spektrum badań, konsultacje u najlepszych specjalistów... Sprawdź ofertę naszej Kliniki położniczo-ginekologicznej: Opieka nad ciężarną, Badania USG w ciąży, Ginekologia...'}
    />
    <div className="content">
      <main>
        <div className="about">
          <section className="about__hero">
            <div className="container">
              <div className="about__hero__content">
                <div className="about__hero__logo">
                  <Link to={"/"}>
                    <svg width={175} height={54} viewBox="0 0 175 54" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M40.64 42.25c-1.123 1.668-2.246 2.295-3.47.312-.714-1.147-1.836-3.129-3.672-6.363l-3.57-6.259c-.613-1.043-1.327-2.086-3.265-.52-1.224 1.042-2.653 2.19-4.591 2.92-1.734.626-6.02-.105-8.57-.313-1.02-.104-2.448.313-3.876.313-1.632 0-3.163-.521-3.163-1.669 0-2.4 1.429-4.59 3.673-4.59 1.734 0 3.163 1.252 4.285 1.252 1.02 0 2.55-.313 4.693-.73 1.734-.314 2.448-2.608 4.488-6.05 2.143-3.651 3.367-7.51 7.754-6.363 2.856.73 6.63 3.964 8.467 7.51a25.156 25.156 0 0 1 2.755 9.283c.51 5.634 0 8.554-1.939 11.267M12.074 12.729c2.755-2.607 6.631-3.13 9.794-1.043 1.836 1.252 3.264 3.233 2.346 4.798-2.652 4.486-3.876 7.72-5.713 8.241-.714.209-1.427.418-2.754.521-1.224.105-3.366-.938-4.489-3.024-1.734-3.13-1.632-7.198.816-9.493M25.836.745C11.566.745 0 12.573 0 27.163s11.567 26.418 25.836 26.418c1.594 0 3.154-.148 4.667-.431-.062-2.241-.228-5.317-.678-5.58-2.04-1.148-5.305-3.234-8.365-5.842-1.224-1.043-3.366-4.277-4.897-6.676-.408-.626-.306-1.252.204-1.356 2.04-.418 4.183 2.608 6.733 4.38 2.551 1.775 6.02 1.357 5.815.836-.612-1.67-1.122-4.173-2.346-6.677-.51-1.043.816-2.19 1.632-.834.714 1.252 1.428 2.504 3.775 6.676 1.938 3.442 3.876 5.216 3.876 11.787v1.48a25.56 25.56 0 0 0 3.43-1.873c.23-2.715 1.1-4.453 2.487-6.491 1.327-1.878 2.245-4.694 2.245-7.824 0-2.399-.307-5.945-.816-8.45-.204-1.042-.204-2.19.51-2.503.918-.417 2.142 2.086 3.672 7.302a15.62 15.62 0 0 1 .442 5.436c-.168 1.864.672 2.323 1.442.451a26.86 26.86 0 0 0 2.008-10.229c0-14.59-11.566-26.418-25.836-26.418m50.631 37.503h4.988V22.882h-4.988zm-6.857-3.691c-.92 0-1.38-.57-1.38-1.98v-6.172h4.431v-3.523h-4.463v-4.597l-4.757.906v3.624l-2.626.838v2.752h2.429v7.414c0 3.12 2.1 4.832 5.151 4.832 3.052 0 5.349-1.745 5.349-1.745l-1.379-3.59c-1.28.906-2.23 1.241-2.755 1.241m101.65-.939c-.392.637-1.902 2.75-4.233 2.75-2.23 0-3.937-1.979-3.937-5.334 0-3.858 2.199-6.072 5.349-6.072 1.41 0 2.755.47 2.822 2.147v6.509zm2.56-.034V14.293l-2.56.47v8.521c-.392-.168-1.378-.537-2.853-.537-5.283 0-8.04 4.094-8.04 8.455 0 4.16 2.493 7.448 6.332 7.448 2.363 0 3.97-1.241 4.79-2.583.165 1.04.46 2.416.46 2.416l2.527-.235s-.656-2.818-.656-4.664zM78.928 14.527c-1.64 0-2.756 1.04-2.756 2.651 0 1.61 1.115 2.65 2.756 2.65 1.64 0 2.789-1.04 2.789-2.65 0-1.61-1.149-2.65-2.79-2.65m69.529 14.594c.361-2.348 1.804-4.194 4.168-4.194 2.953 0 3.248 3.221 3.248 3.221l-7.416.973zm10.237.37c0-4.329-2.493-6.744-5.905-6.744-4.2 0-7.088 3.556-7.088 8.287 0 3.959 2.428 7.616 7.317 7.616 3.544 0 5.676-2.181 5.676-2.181l-.754-2.013s-2.1 1.912-4.627 1.912c-2.887 0-4.659-2.114-4.888-5.234l8.695-1.174 1.574-.47zm-47.413 4.025c-.787 1.007-1.64 1.644-2.592 1.644-.623 0-1.083-.268-1.083-1.14 0-1.309 1.05-2.382 3.675-2.785v2.281zm4.955-.57v-5.402c0-3.321-1.247-5.066-5.447-5.066-4.56 0-7.251 2.047-7.251 2.047l1.05 3.456s2.33-1.88 4.987-1.88c1.214 0 1.706.605 1.706 1.947v.57c-5.447.738-8.662 2.583-8.662 5.871 0 2.45 1.87 4.16 4.726 4.16 2.854 0 4.134-1.643 4.528-2.348.688 1.174 2.001 2.214 4.691 2.18l1.379-3.925s-1.707.034-1.707-1.61zm22.608-10.2c-2.659 0-4.857 1.98-5.874 3.02-.427-2.147-1.804-3.02-3.544-3.02-2.756 0-5.02 2.08-5.94 3.087v-2.919l-2.558.47v14.863h2.559V28.25c.853-.873 3.347-3.188 5.25-3.188 1.017 0 1.837.705 1.837 2.953v10.233h2.56V28.015c1.05-1.007 3.282-2.953 5.02-2.953 1.017 0 1.837.705 1.837 2.953v10.233h2.56V27.277c0-3.255-1.607-4.53-3.707-4.53m-41.278-8.22c-1.64 0-2.756 1.04-2.756 2.651 0 1.61 1.115 2.65 2.756 2.65 1.64 0 2.789-1.04 2.789-2.65 0-1.61-1.148-2.65-2.789-2.65m-11.78 23.72h4.988V14.125l-4.988.805zm9.319 0h4.987V22.882h-4.987z"
                        fill="#FFF" fillRule="evenodd"/>
                    </svg>
                  </Link>
                </div>
                <h1 className="about__hero__heading">
                  Kobiecość i zdrowie w centrum uwagi. </h1>
                <h2 className="about__hero__subheading">
                  W centrum medycznym Tiliamed uzyskasz pomoc i odpowiedzi na wszystkie pytania. </h2>
              </div>
            </div>
            <div className="about__hero__image">
              <img src="/images/about-hero.jpg"
                   className="img-responsive hidden-xs" alt="O nas baner"/>
            </div>
          </section>
          <section className="about__intro">
            <div className="container">
              <div className="row">
                <div className="col-sm-6">
                  <p className="about__intro__heading">
                    Dowiedz się więcej o historii Tiliamed. </p>
                </div>
                <div className="col-sm-6">
                  <div className="about__intro__text">
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="about__doctors">
            <div className="container">
              <div className="about__doctors__person">
                <div className="row">
                  <div className="col-sm-6 ">
                    <div className="about__doctors__person__photo">
                      <img src="/wp-uploads/2017/01/portret-andrzej.png"
                           className="img-responsive" alt="tiliamed wołomin lipa andrzej"/>
                    </div>
                  </div>
                  <div className="col-sm-6 ">
                    <p className="about__doctors__person__name">lek. Andrzej Lipa</p>
                    <div className="about__doctors__person__desc">
                      <p>Specjalista położnictwa i ginekologii, absolwent Wydziału Lekarskiego Akademii Medycznej w
                        Lublinie. Przez ponad 25 lat pracy zawodowej związany z Oddziałem Położniczo- Ginekologicznym w
                        Szpitalu Powiatowym w Wołominie, gdzie od 2016 roku pełni rolę Zastępcy Ordynatora. Członek
                        Polskiego Towarzystwa Ginekologicznego oraz aktywny uczestnik spotkań Oddziału Warszawskiego
                        PTG. Główne zainteresowania zawodowe związane z położnictwem, prowadzeniem ciąży oraz
                        ultrasonografią. Hobby w wolnym czasie- tenis i podróże.</p>
                    </div>
                    <div className="about__doctors__person__tabs">
                      <div className="nav-tabs__wrapper">
                        <ul className="nav nav-tabs" role="tablist">
                          <li role="presentation" className="active">
                            <a href="#doctor-0-education" aria-controls="education" role="tab" data-toggle="tab">
                              <svg width={15} height={19} viewBox="0 0 15 19" xmlns="http://www.w3.org/2000/svg">
                                <title>Page 1</title>
                                <g fill="none" fillRule="evenodd">
                                  <path fill="#020203" d="M4 7h6V5H4zm0 8h5v-2H4zm0-3.999h4V9H4zm9 7.445h2V4.029h-2z"/>
                                  <path
                                    d="M0 .82v18h15v-1.7l-1 .5v-3.9l-.5-.3a2.857 2.857 0 0 1-.5-.376v3.776H2v-14h11v5.75a2.986 2.986 0 0 1 2-.75v-7H0z"
                                    fill="#1D1C1B"/>
                                </g>
                              </svg>
                              <span>Wykształcenie</span>
                            </a>
                          </li>
                          <li role="presentation">
                            <a href="#doctor-0-work" aria-controls="work" role="tab" data-toggle="tab">
                              <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <title>praca</title>
                                <path
                                  d="M2 18h16V6H2v12zM8 4h4V2H8v2zm10 0h-1V3h-2v1h-1V2c0-1.1-.9-2-2-2H8C6.9 0 6 .9 6 2v2H5V3H3v1H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
                                  fillRule="evenodd"/>
                              </svg>
                              <span>Praca</span>
                            </a>
                          </li>
                          <li role="presentation">
                            <a href="#doctor-0-certificates" aria-controls="certificates" role="tab" data-toggle="tab">
                              <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                   xmlnsXlink="http://www.w3.org/1999/xlink"><title>wyksztalcenie</title>
                                <defs>
                                  <path id="a" d="M0 20h20V0H0z"/>
                                </defs>
                                <g fill="none" fillRule="evenodd">
                                  <path
                                    d="M16.5 12.6l-.5.3v3.9l-1-.5-1 .5v-3.9l-.5-.3c-.9-.5-1.5-1.5-1.5-2.6 0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.1-.6 2.1-1.5 2.6zM2 16V2h11v3.4c-1.8.8-3 2.6-3 4.6 0 1.6.8 3.1 2 4v2H2zM15 5V0H0v18h12v2l3-1.5 3 1.5v-6c1.2-.9 2-2.4 2-4 0-2.8-2.2-5-5-5z"
                                    fill="#000"/>
                                  <mask id="b" fill="#fff">
                                    <use xlinkHref="#a"/>
                                  </mask>
                                  <path fill="#000" mask="url(#b)" d="M4 6h6V4H4zm0 8h5v-2H4zm0-4h4V8H4z"/>
                                </g>
                              </svg>
                              <span>Certyfikaty</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="tab-content">
                        <div role="tabpanel" className="tab-pane fade in active" id="doctor-0-education">
                          <ul>
                            <li>Absolwent Wydziału Lekarskiego Akademii Medycznej w Lublinie (1987)</li>
                            <li>I stopień specjalizacji z położnictwa i ginekologii (1992)</li>
                            <li>II stopień specjalizacji z położnictwa i ginekologii (1997)</li>
                          </ul>
                        </div>
                        <div role="tabpanel" className="tab-pane fade" id="doctor-0-work">
                          <ul>
                            <li>Młodszy asystent w Oddziale Położnictwa i Ginekologii w Powiatowym Szpitalu w Wołominie
                              (1988)
                            </li>
                            <li>Starszy asystent w Oddziale Położnictwa i Ginekologii w Powiatowym Szpitalu w Wołominie
                              (1998)
                            </li>
                            <li>Zastępca Ordynatora od 2016 roku</li>
                          </ul>
                        </div>
                        <div role="tabpanel" className="tab-pane fade" id="doctor-0-certificates">
                          <p>
                            – <a href="/wp-uploads/2017/01/AL5.jpg" data-lightbox="doctor-0"
                                 data-title="Certyfikat USG FMF (Fetal Medicine Foundation; Londyn, Wielka Brytania).">
                            Certyfikat USG FMF (Fetal Medicine Foundation; Londyn, Wielka Brytania). </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="about__doctors__person">
                <div className="row">
                  <div className="col-sm-6 col-sm-push-6">
                    <div className="about__doctors__person__photo">
                      <img src="/wp-uploads/2017/01/portret-michal.png"
                           className="img-responsive" alt="tiliamed michał"/>
                    </div>
                  </div>
                  <div className="col-sm-6 col-sm-pull-6">
                    <p className="about__doctors__person__name">dr n. med. Michał Lipa</p>
                    <div className="about__doctors__person__desc">
                      <p>Lekarz rezydent położnictwa i ginekologii w I Klinice Położnictwa i Ginekologii Warszawskiego
                        Uniwersytetu Medycznego przy pl. Starynkiewicza 1/3 w Warszawie. Doświadczenie z zakresu badania
                        USG zdobywał w szpitalach w Polsce i Japonii. Główne zainteresowania związane z perinatologią:
                        diagnostyką ultrasonograficzną w trakcie ciąży (ze szczególnym uwzględnieniem diagnostyki wad
                        ośrodkowego układu nerwowego u płodów), ciążą bliźniaczą, patologią ciąży i terapią płodu.</p>
                      <p>W 2018 roku uzyskał tytuł doktora nauk medycznych za obronę pracy doktorskiej pt. "Ocena
                        łożyskowych struktur naczyniowych w zaburzeniach wzrastania w ciążach mnogich".</p>
                      <p>Członek Klubu “35” działającego przy Polskim Towarzystwie Ginekologów i Położników zrzeszającym
                        młodych naukowców, członek Zarządu ENTOG Polska oraz aktywny członek International Society of
                        Ultrasound in Obstetrics and Gynecology (ISUOG).</p>
                    </div>
                    <div className="about__doctors__person__tabs">
                      <div className="nav-tabs__wrapper">
                        <ul className="nav nav-tabs" role="tablist">
                          <li role="presentation" className="active">
                            <a href="#doctor-1-education" aria-controls="education" role="tab" data-toggle="tab">
                              <svg width={15} height={19} viewBox="0 0 15 19" xmlns="http://www.w3.org/2000/svg">
                                <title>Page 1</title>
                                <g fill="none" fillRule="evenodd">
                                  <path fill="#020203" d="M4 7h6V5H4zm0 8h5v-2H4zm0-3.999h4V9H4zm9 7.445h2V4.029h-2z"/>
                                  <path
                                    d="M0 .82v18h15v-1.7l-1 .5v-3.9l-.5-.3a2.857 2.857 0 0 1-.5-.376v3.776H2v-14h11v5.75a2.986 2.986 0 0 1 2-.75v-7H0z"
                                    fill="#1D1C1B"/>
                                </g>
                              </svg>
                              <span>Wykształcenie</span>
                            </a>
                          </li>
                          <li role="presentation">
                            <a href="#doctor-1-work" aria-controls="work" role="tab" data-toggle="tab">
                              <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <title>praca</title>
                                <path
                                  d="M2 18h16V6H2v12zM8 4h4V2H8v2zm10 0h-1V3h-2v1h-1V2c0-1.1-.9-2-2-2H8C6.9 0 6 .9 6 2v2H5V3H3v1H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
                                  fillRule="evenodd"/>
                              </svg>
                              <span>Praca</span>
                            </a>
                          </li>
                          <li role="presentation">
                            <a href="#doctor-1-certificates" aria-controls="certificates" role="tab" data-toggle="tab">
                              <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                   xmlnsXlink="http://www.w3.org/1999/xlink"><title>wyksztalcenie</title>
                                <defs>
                                  <path id="a" d="M0 20h20V0H0z"/>
                                </defs>
                                <g fill="none" fillRule="evenodd">
                                  <path
                                    d="M16.5 12.6l-.5.3v3.9l-1-.5-1 .5v-3.9l-.5-.3c-.9-.5-1.5-1.5-1.5-2.6 0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.1-.6 2.1-1.5 2.6zM2 16V2h11v3.4c-1.8.8-3 2.6-3 4.6 0 1.6.8 3.1 2 4v2H2zM15 5V0H0v18h12v2l3-1.5 3 1.5v-6c1.2-.9 2-2.4 2-4 0-2.8-2.2-5-5-5z"
                                    fill="#000"/>
                                  <mask id="b" fill="#fff">
                                    <use xlinkHref="#a"/>
                                  </mask>
                                  <path fill="#000" mask="url(#b)" d="M4 6h6V4H4zm0 8h5v-2H4zm0-4h4V8H4z"/>
                                </g>
                              </svg>
                              <span>Certyfikaty</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="tab-content">
                        <div role="tabpanel" className="tab-pane fade in active" id="doctor-1-education">
                          <p>Absolwent I Wydziału Lekarskiego Warszawskiego Uniwersytetu Medycznego w Warszawie
                            (2014)</p>
                        </div>
                        <div role="tabpanel" className="tab-pane fade" id="doctor-1-work">
                          <ul>
                            <li>Lekarz rezydent w I Klinice Położnictwa i Ginekologii Warszawskiego Uniwersytetu
                              Medycznego od 2016
                            </li>
                          </ul>
                        </div>
                        <div role="tabpanel" className="tab-pane fade" id="doctor-1-certificates">
                          <p>
                            – <a href="/wp-uploads/2017/01/certificate-1.jpg"
                                 data-lightbox="doctor-1"
                                 data-title="Certyfikat USG FMF (Fetal Medicine Foundation; Londyn, Wielka Brytania)">
                            Certyfikat USG FMF (Fetal Medicine Foundation; Londyn, Wielka Brytania) </a>
                          </p>
                          <p>
                            – <a href="/wp-uploads/2017/01/FullSizeRender.jpg"
                                 data-lightbox="doctor-1" data-title="Certyfikat szkolenia CRFIM (Osaka, Japonia)">
                            Certyfikat szkolenia CRFIM (Osaka, Japonia) </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="about__timeline">
            <div className="container">
              <p className="about__timeline__heading text-center">Oś czasu</p>
              <div className="cd-horizontal-timeline">
                <div className="timeline">
                  <div className="events-wrapper">
                    <div className="events">
                      <ol>
                        <li>
                          <a href="#0" data-date="01/01/1998" className="selected">
                            1998 </a>
                        </li>
                        <li>
                          <a href="#0" data-date="01/01/2016" className>
                            2016 </a>
                        </li>
                        <li>
                          <a href="#0" data-date="01/01/2017" className>
                            2017 </a>
                        </li>
                      </ol>
                      <span className="filling-line" aria-hidden="true"/>
                    </div>
                  </div>
                  <ul className="cd-timeline-navigation">
                    <li><a href="#0" className="prev inactive">
                      <svg width={11} height={20} viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg"><title>strzałka
                        lewo</title>
                        <path
                          d="M3.316 9.622l7.299 7.298a1.375 1.375 0 0 1-1.944 1.944l-8.25-8.25c-.26-.25-.421-.6-.421-.99 0-.394.161-.745.42-.995L8.67.38c.25-.234.585-.38.955-.38a1.375 1.375 0 0 1 .895 2.418L3.316 9.622z"
                          fill="#9F9F9F" fillRule="evenodd"/>
                      </svg>
                    </a></li>
                    <li><a href="#0" className="next">
                      <svg width={11} height={20} viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg"><title>strzalka
                        prawo</title>
                        <path
                          d="M.48 16.832l7.203-7.204L.385 2.33A1.375 1.375 0 0 1 2.33.386V.384l8.25 8.25c.26.25.42.601.42.99v.006c0 .389-.16.74-.42.99l-8.25 8.25-.003-.004A1.375 1.375 0 1 1 .48 16.831"
                          fill="#9F9F9F" fillRule="evenodd"/>
                      </svg>
                    </a></li>
                  </ul>
                </div>
                <div className="events-content">
                  <ol>
                    <li className="selected" data-date="01/01/1998">
                      <p className="about__timeline__event__heading">Początek własnej praktyki
                        położniczo-ginekologicznej</p>
                      <div className="about__timeline__event__image">
                        <img className="img-responsive center-block"
                             src="/wp-uploads/2017/01/tiliamed_preview-289-of-317-e1487536683341.jpg"
                             alt="tiliamed ginekolog wołomin"/>
                      </div>
                      <div className="about__timeline__event__content">
                        <div className="row">
                          <div className="col-sm-offset-2 col-sm-8">
                            <p>Rozpoczęcie praktyki lekarskiej o profilu położniczo- ginekologicznym. Miniony czas to
                              tysiące ciąż, doświadczeń i wiele miłych momentów po szczęśliwym zakończeniu ciąży.</p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className data-date="01/01/2016">
                      <p className="about__timeline__event__heading">Do zespołu dołącza dr Michał Lipa</p>
                      <div className="about__timeline__event__image">
                        <img className="img-responsive center-block"
                             src="/wp-uploads/2017/01/tiliamed_preview-284-of-317-e1487536700112.jpg"
                             alt="Klinika położniczo-ginekologiczna"/>
                      </div>
                      <div className="about__timeline__event__content">
                        <div className="row">
                          <div className="col-sm-offset-2 col-sm-8">
                            <p>W 2016 roku do Tiliamedu dołączył syn, dr Michał Lipa</p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className data-date="01/01/2017">
                      <p className="about__timeline__event__heading">Nowa nazwa i logo</p>
                      <div className="about__timeline__event__image">
                        <img className="img-responsive center-block"
                             src="/wp-uploads/2017/01/Zrzut-ekranu-2016-10-21-o-17.34.00-e1487536828693.png"
                             alt="tiliamed"/>
                      </div>
                      <div className="about__timeline__event__content">
                        <div className="row">
                          <div className="col-sm-offset-2 col-sm-8">
                            <p>Chęć dalszego rozwoju sprawiła, że praktyka położniczo- ginekologiczna dr Andrzeja Lipy
                              zyskała nową nazwę i logo.</p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ol>
                  <div className="cd-slide-navigation">
                    <a href="#" className="prev inactive">
                      <svg width={11} height={20} viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg"><title>strzałka
                        lewo</title>
                        <path
                          d="M3.316 9.622l7.299 7.298a1.375 1.375 0 0 1-1.944 1.944l-8.25-8.25c-.26-.25-.421-.6-.421-.99 0-.394.161-.745.42-.995L8.67.38c.25-.234.585-.38.955-.38a1.375 1.375 0 0 1 .895 2.418L3.316 9.622z"
                          fill="#9F9F9F" fillRule="evenodd"/>
                      </svg>
                    </a>
                    <a href="#" className="next">
                      <svg width={11} height={20} viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg"><title>strzalka
                        prawo</title>
                        <path
                          d="M.48 16.832l7.203-7.204L.385 2.33A1.375 1.375 0 0 1 2.33.386V.384l8.25 8.25c.26.25.42.601.42.99v.006c0 .389-.16.74-.42.99l-8.25 8.25-.003-.004A1.375 1.375 0 1 1 .48 16.831"
                          fill="#9F9F9F" fillRule="evenodd"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
    <TableOfContents/>
  </Layout>
)
